import { motion, AnimatePresence } from 'framer-motion'
import { FiX } from 'react-icons/fi'

// Slide único ativo
const activeSlide = {
  id: 1,
  video: '/promo/promo-beliche.mp4',
  mobileVideo: '/promo/promo-beliche.mp4', // Mesma imagem para mobile por padrão
  title: 'Promoção Especial de Beliches!',
  description: 'Aproveite nossas ofertas de beliches com parcelamento em até 3x sem juros.',
  buttonText: 'VER OFERTAS',
  buttonLink: '#contato' // Link do botão atualizado para a seção de contato
}

// Slides para o carrossel (comentado para uso futuro)
/*
const slides = [
  {
    id: 1,
    image: '/images/promo/promo-1.jpg',
    title: 'Promoção Especial',
    description: 'Aproveite nossos serviços com desconto especial',
    buttonText: 'APROVEITE',
    buttonLink: '#contato'
  },
  {
    id: 2,
    image: '/images/promo/promo-2.jpg',
    title: 'Novos Projetos',
    description: 'Conheça nossos novos projetos e soluções',
    buttonText: 'SAIBA MAIS',
    buttonLink: '#services'
  },
  {
    id: 3,
    image: '/images/promo/promo-3.jpg',
    title: 'Parceria Exclusiva',
    description: 'Benefícios exclusivos para nossos clientes',
    buttonText: 'CONTATE-NOS',
    buttonLink: '#contato'
  }
]
*/

interface PopupSliderProps {
  isOpen: boolean
  onClose: () => void
}

export default function PopupSlider({ isOpen, onClose }: PopupSliderProps) {
  // Código para múltiplos slides (comentado para uso futuro)
  /*
  const [currentSlide, setCurrentSlide] = useState(0)
  
  // Auto-avançar slides a cada 5 segundos
  useEffect(() => {
    if (!isOpen) return
    
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length)
    }, 5000)
    
    return () => clearInterval(interval)
  }, [isOpen])
  
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length)
  }
  
  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
  }
  */

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            className="relative mx-0 sm:mx-4 w-full sm:w-[95%] max-w-4xl overflow-hidden rounded-t-none sm:rounded-xl bg-dark-primary shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Botão de fechar */}
            <button
              onClick={onClose}
              className="absolute right-2 top-2 z-10 rounded-full bg-black bg-opacity-50 p-1 text-white transition-all hover:bg-opacity-70"
              aria-label="Fechar"
            >
              <FiX size={24} />
            </button>
            
            <div className="flex flex-col md:flex-row">
              {/* Lado esquerdo - Conteúdo */}
              <div className="flex w-full flex-col justify-between p-4 sm:p-6 md:p-8 md:w-1/2 order-2 md:order-1">
                <div className="w-full">
                  <h2 className="mb-3 text-xl sm:text-2xl md:text-3xl font-bold text-white text-center md:text-left">
                    {activeSlide.title}
                  </h2>
                  <p className="mb-4 sm:mb-6 text-sm sm:text-base text-gray-200 text-center md:text-left">
                    {activeSlide.description}
                  </p>
                </div>
                
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4 w-full">
                  <div className="text-center sm:text-left">
                    <span className="text-2xl sm:text-3xl font-bold text-green-400">R$ 799,00</span>
                    <p className="text-xs text-gray-300">à vista no PIX</p>
                  </div>
                  <a
                    href={activeSlide.buttonLink}
                    onClick={onClose}
                    className="w-full sm:w-auto rounded-lg bg-green-600 px-4 py-2.5 sm:px-6 sm:py-3 text-sm sm:text-base font-semibold text-white shadow-md transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-green-700 text-center whitespace-nowrap"
                  >
                    {activeSlide.buttonText}
                  </a>
                  
                  {/* Indicadores de slide (comentado para uso futuro) */}
                  {/*
                  <div className="mt-6 flex space-x-2">
                    {slides.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentSlide(index)}
                        className={`h-2 w-8 rounded-full transition-all ${
                          index === currentSlide
                            ? 'bg-light-accent dark:bg-dark-accent'
                            : 'bg-gray-300 dark:bg-gray-600'
                        }`}
                        aria-label={`Ir para slide ${index + 1}`}
                      />
                    ))}
                  </div>
                  */}
                </div>
              </div>
              
              {/* Lado direito - Imagem */}
              <div className="relative w-full md:w-1/2 order-1 md:order-2 flex items-center justify-center bg-black/5 p-4">
                <div className="relative w-full h-auto max-h-[40vh] md:max-h-[50vh] aspect-video flex items-center justify-center">
                  <video 
                    key={activeSlide.video}
                    autoPlay 
                    loop 
                    muted 
                    playsInline
                    className="w-full h-full object-contain shadow-lg rounded-lg"
                  >
                    <source src={activeSlide.video} type="video/mp4" />
                    Seu navegador não suporta o formato de vídeo.
                  </video>
                  
                  {/* Botões de navegação (comentado para uso futuro) */}
                  {/*
                  <button
                    onClick={prevSlide}
                    className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-black bg-opacity-50 p-2 text-white transition-all hover:bg-opacity-70"
                    aria-label="Slide anterior"
                  >
                    <FiChevronLeft size={24} />
                  </button>
                  <button
                    onClick={nextSlide}
                    className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-black bg-opacity-50 p-2 text-white transition-all hover:bg-opacity-70"
                    aria-label="Próximo slide"
                  >
                    <FiChevronRight size={24} />
                  </button>
                  */}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
